<!--
 * @Description: 服务项目页面
 * @Author: sunhuihong
 * @Date: 2022-05-25 16:43:52
 * @LastEditTime: 2022-12-27 16:32:14
-->
<template>
  <div class="body">
    <el-row style="margin: 25px 40px" :gutter="0" type="flex" justify="space-between" >
      <el-col :span="8" style="text-align: left;">
        <span class="search-title">机构名称：</span>
        <el-select style="width: 240px;" size="small" filterable  v-model="filterParams.institutionId" clearable 
          placeholder="请输入/选择" 
          :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList', srcInstitutionList, this))"
					@visible-change="(visible) => 
          commonUtil.handleListFilterVisibleChange(visible, 'institutionList', srcInstitutionList, this)">
          <el-option v-for="item in institutionList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" style="text-align: center">
        <span class="search-title">服务名称：</span>
        <el-input size="small"  style="width: 240px;"  v-model="filterParams.hserviceName" clearable 
          placeholder="请输入服务名称">
        </el-input>
      </el-col>
      <el-col :span="8" style="text-align: right">
        <span class="search-title">服务类型：</span>
        <el-select size="small" filterable  v-model="filterParams.hserviceTypeCfgId" clearable style="width: 240px;" 
          placeholder="请选择">
          <el-option v-for="item in hserviceTypeCfgList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row class="bk-search" style="margin: 25px 40px;" :gutter="0" type="flex" justify="space-between">
      <el-col :span="24" style="text-align: right;">
        <el-button v-if="dataPvgList.includes('HSVC_4_IMPORT')" size="small" class="import-style" 
          @click="handleSystemImport" plain >
          模板导入
        </el-button >
        <el-button size="small" type="primary" icon="el-icon-search" @click="handleQuery" style="width: 80px;">
          搜 索
        </el-button>
        <el-button v-if="dataPvgList.includes('HSVC_1_CREATE')" size="small" icon="el-icon-plus"
          type="primary" @click="handleAddHserviceCfg" style="width: 80px;">
          新 增
        </el-button>
      </el-col>      
    </el-row>
    <div class="main-line"></div>
    <el-table style="margin: 0 40px; border: 1px solid #f0f0f0;" :style="tableWidth" ref="table" :data="dataTable" 
      :header-cell-style="{ 'text-align': 'left','background-color': '#EFF5FA'}">
        <el-table-column prop="institutionText" label="所属机构" min-width="14%" align="left"></el-table-column>
        <el-table-column prop="name" label="服务名称" min-width="12%" align="left"></el-table-column>
        <el-table-column prop="hsevicePkgPriceYuan" sortable label="服务价格" min-width="12%" align="left"
          :sort-method="(a,b)=>{return a.hsevicePkgPriceYuan - b.hsevicePkgPriceYuan}">
          <template slot-scope="scope">
            <span>{{scope.row.hsevicePkgPriceYuan+'起'}}</span>
          </template>
        </el-table-column>
        <el-table-column  label="服务类型" min-width="12%" align="left">
          <template slot-scope="scope">
            <span>{{scope.row.hserviceTypeCfgText == '' ? '- -' : scope.row.hserviceTypeCfgText}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="addTime" label="创建时间" sortable min-width="14%" align="left">
          <template slot-scope="scope">{{rebuildDate(scope.row.addTime)}}</template>
        </el-table-column>
        <el-table-column prop="creatorText" label="创建人"  min-width="10%" align="left"></el-table-column>
        <el-table-column  label="启用状态" min-width="10%" align="left" >
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0" active-color="#13ce66" 
              :disabled="!dataPvgList.includes('HSVC_5_STATUS_CHG')"  
              @change="handleStatusSwitch(scope.$index,scope.row.status,scope.row.id)">
            </el-switch>
         </template>
        </el-table-column>
        <el-table-column  label="操作" min-width="16%" align="left">
          <template slot-scope="scope">
            <el-button  type="text" size="small" @click="handleDetailHserviceCfg(scope.row)">详情</el-button>
            <template v-if="dataPvgList.includes('HSVC_2_UPDATE')">
              <el-divider direction="vertical"></el-divider>
              <el-button  type="text" size="small" @click="handleEditHserviceCfg(scope.row)">编辑</el-button>
            </template>
            <template v-if="dataPvgList.includes('HSVC_6_HSP_BINDING') || dataPvgList.includes('HSVC_3_DELETE')">
              <el-divider direction="vertical"></el-divider>
              <el-dropdown>
                <el-button type="text" size="small">
                  更多
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="dataPvgList.includes('HSVC_6_HSP_BINDING')" @click.native="handleBindingHopital(scope.row)">
                    <span style="color: #3E7EF5;">
                    绑定医院
                    </span>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="dataPvgList.includes('HSVC_3_DELETE')"
                    @click.native="handleDeleteHserviceCfg(scope.row)">
                    <span style="color: #FF3434;">
                      删除
                    </span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>
        </el-table-column>
    </el-table>
    <el-row class="foot-pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage" 
      :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize" 
      layout="total, prev, pager, next, sizes, jumper" :total="totalNumber" />
    </el-row>
    
    <!-- 服务项目详情dialog -->
    <hservice-details :showHserviceDetails="showHserviceDetails" :mode="dialogMode" 
      :hsvcId="hsvcId" :institutionId="filterParams.institutionId"  @close-dialog="closeHserviceCfgDialog"/>

    <!-- 导入服务项目dialog -->
    <hservice-import :showHserviceImportDialog="showHserviceImportDialog" :instiutionId="filterParams.institutionId" 
      @save-import-hservice="saveImportHservice" @close-hservice-import="closeHserviceImport"/>

    <!-- 绑定医院dialog -->
    <binding-hospital :visible="showBindingHospitalDialog" :hsvcId="hsvcId" 
      @close-dialog="closeBindingHospitalDialog"/>
  </div>
</template>

<script>
import Util from '@/global/Util.js'
import Constant from '@/global/Constant.js'
import HserviceDetails from './components/HserviceDetails.vue'
import HserviceImport from './components/HserviceImport.vue'
import BindingHospital from './components/BindingHospital.vue'

export default {
  name: 'HserviceList',
  components: {
    'hservice-details': HserviceDetails,
    'hservice-import': HserviceImport,
    'binding-hospital': BindingHospital
  },

  data() {
    return {
      dataPvgList: [],    //在角色配置页面上的操作权限
      filterParams: {
        page: 1,
        pageSize: this.commonConst.PAGE_SIZE,
      },
      pageSizes: this.commonConst.PAGE_SIZES,
      
      institutionList: [],//机构数据
      srcInstitutionList: [],
      hserviceTypeCfgList: [],//服务类型数据
      totalNumber: 0,
      dataTable: [],
      showHserviceDetails: false,
      dialogMode: '', 
      hsvcId: '',
      showHserviceImportDialog: false,//是否显示系统导入dialog

      showBindingHospitalDialog: false,//是否显示绑定医院dialog
    }
  },
  
  computed: {
    tableWidth() {
      return 'width:' + (this.$root.contentWidth - 80) + 'px';
    },
  },
  
  methods: {
    async initData() {
      await this.getDataPvg4CurRole(); 
      await this.getFilterDo();
      await this.listHservice();
    },

    getDataPvg4CurRole() {
      return new Promise((resolve) => {
        let requestData = {
          method: 'GET',
          url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
          param: {entityKey: 'HSVC'},
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataPvgList = result.data;
            resolve();
          }
        })
      })
    },

    //查询过滤条件
    getFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_HSERVICE_FILTER_DO).then(result => {
          if (result != null) {
            this.institutionList = result.data.simpleInstitutionList;
            this.srcInstitutionList = result.data.simpleInstitutionList;
            this.hserviceTypeCfgList = Util.changeArrPosition(result.data.hserviceTypeCfgList);
            //如果从机构跳转过来的携带机构ID
            if(this.$route.params.institutionId) {
              this.$set(this.filterParams, 'institutionId', this.$route.params.institutionId)
            } else if (this.globalData.adminType == 2) {
              this.$set(this.filterParams, 'institutionId', this.institutionList[0].id);
            }
            resolve();
          }
        })
      })
    },

    //获取table表格数据
    listHservice() {
      return new Promise((resolve) => {
        let header = this.encryptionUtil.signatureParams(this.filterParams,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_PAGE_HSERVICES,
          param: this.filterParams,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };

        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataTable = result.data;
            this.totalNumber = result.totalNumber;
            resolve();
          }
        })
      })
    },

    //搜索
    handleQuery() {
      this.filterParams.page = 1;
      this.listHservice();
    },
    
    //新增
    handleAddHserviceCfg() {
      this.showHserviceDetails = true;
      this.dialogMode = "add";
      this.hsvcId = 0;
    },

    //系统导入服务项目
    handleSystemImport() {
      if(this.filterParams.institutionId == undefined || this.filterParams.institutionId == ''){
        this.$message.error( "请先选择机构");
        return;
      }
      this.showHserviceImportDialog = true;
    },

    //启用状态改变
    handleStatusSwitch(index, statu, hsvcId) {
      let item = this.dataTable[index];
      item.status = statu == 1 ? 0 : 1;//这里未确定的时候，switch的值取反还原
      let status = statu == 1 ? "enable" : "disable";
      let strMessage = statu == 1 ? '确认是否启用？' : '确认是否停用？';
      this.$confirm(strMessage, '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        this.queryStatusChange(hsvcId, status);
      })
    },

    queryStatusChange(hsvcId, status) {
      let params = {
        id: hsvcId,
        status: status
      };
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'PUT',
        url: Constant.URL_UPDATE_HSERVICE_STATUS,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(_result => {
        this.listHservice();
      });
    },

    //详情
    handleDetailHserviceCfg(item) {
      this.dialogMode = 'details';
      this.hsvcId = item.id;
      this.showHserviceDetails = true;
    },

    //编辑
    handleEditHserviceCfg(item) {
      this.showHserviceDetails = true;
      this.dialogMode = 'edit';
      this.hsvcId = item.id;
    },

    //删除
    handleDeleteHserviceCfg(item) {
      let strMessage = item.status == 0 ? item.name +'服务将被删除，是否继续删除？':'请先关闭启用，再进行删除操作';
      this.$confirm(strMessage, '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        //停用时执行删除
        if(item.status == 0) {
          this.deleteServiceList(item);
        }
      })
    },

    deleteServiceList(item) {
      let params = {id: item.id};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'DELETE',
        url: Constant.URL_DELETE_HSERVICE_LIST,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(_result => {
        this.listHservice();
      });
    },

    //当导入dialog里面切换了导入的机构，确定导入后，关闭dialog列表页面的机构应该保持和dialog导入的一致
    saveImportHservice(data) {
      this.filterParams.institutionId = data;
      this.showHserviceImportDialog = false;
      this.listHservice();
    },

    closeHserviceCfgDialog(refresh, hsvcId) {
      this.showHserviceDetails = false;
      if (refresh) this.listHservice();
      //新增服务项目成功后需要显示绑定医院弹框
      if (this.dialogMode == 'add' && refresh) {
        this.hsvcId = hsvcId;
        this.showBindingHospitalDialog = true;
      }
    },

    //关闭系统导入dialog
    closeHserviceImport(refresh) {
      this.showHserviceImportDialog = false;
      if (refresh) this.listHservice();
    },

    //绑定医院
    handleBindingHopital(row) {
      this.hsvcId = row.id;
      this.showBindingHospitalDialog = true;
    },

    //关闭取消绑定医院弹框
    closeBindingHospitalDialog(refresh) {
      this.showBindingHospitalDialog = false;
      if (refresh) this.listHservice();
    },

    //以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.listHservice();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.listHservice();
    },

    rebuildDate(date) {
      return this.dateUtil.dateTimeFormat(date, "YYYY-MM-DD HH:mm");
    },
  },

  mounted() {
    this.$emit("breadcrumb", {text1: '服务管理', text2: '服务项目'});
    this.initData();
  }
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.search-title {
  color: #657180;
  font-size: 14px;
  display: inline-block;
  text-align: right;
}

.main-line {
  height: 10px;
  background-color: #f0f0f0;
  margin: 15px 0 ;
}

.foot-pagination {
  margin-top: 57px;
  text-align: right;
  right: 40px;
  border: solid 0px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #3E7EF5;
}

.el-dropdown-link-dis {
  cursor: pointer;
  color: #999999;
}

.import-style {
  background: #EDF5FF;
  border: 1px solid #B4D8FF;
  color: #3E7EF5;
}
</style>


// WEBPACK FOOTER //
// src/components/hsvcmng/HserviceList.vue